import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { forgotPassword } from "services";
import { setGuestUser } from "store";
import {
  BetaForm as useBetaForm,
  TextInputBase,
  ButtonBase,
} from "@reusejs/react";
import ResendCode from "./ResendCode";
import Link from "next/link";
import ChevronLeftSvg from "../../Icons/ChevronLeftSvg";

export default function ForgotPasswordForm() {
  const dispatch = useDispatch();
  const guestUser = useSelector((state: any) => {
    return state.auth.guestUser;
  });
  const [success, setSuccess] = useState(false);

  const form = useBetaForm({
    email: "",
  });

  const form_constraints = {
    email: {
      presence: {
        allowEmpty: false,
      },
      email: true,
    },
  };

  useEffect(() => {
    form.setValidationRules(form_constraints);
  }, []);

  const handleForgotPassword = async () => {
    try {
      if (form.validate()) {
        let prefix_url = "https://auctionbazaar.com";

        if (window !== undefined) {
          prefix_url = `${window.location.origin}/resetpassword`;
        }

        await forgotPassword(form, prefix_url).then((res: any) => {
          dispatch(setGuestUser({ guestUser: form.value }));
          setSuccess(true);
        });
      }
    } catch (error) {
      console.log("check here forgot error", error);
    }
  };

  return (
    <div className="px-4 sm:px-6 lg:px-20 xl:px-24 flex">
      <div className="mx-auto w-full max-w-md lg:w-96 ">
        <div className="flex flex-col justify-center h-screen md:h-[initial]">
          {!success ? (
            <>
              <h2 className="md:mt-6 text-2xl md:text-3xl font-semibold text-gray-900 tracking-tight">
                Forgot password?
              </h2>
              <p className="mt-1.5 md:mt-3 text-base text-gray-600 font-normal">
                No worries, we’ll send you reset instructions.
              </p>
              <div className="mt-8">
                <TextInputBase
                  labelBaseProps={{
                    label: "Email*",
                  }}
                  name={"email"}
                  onChange={(val) => form.setField("email", val)}
                  placeholder={"Enter your email"}
                  type={"text"}
                  error={
                    form.errors.get("email") ? (
                      <p className="mt-2 text-sm text-red-500">
                        {form.errors.get("email")[0]}
                      </p>
                    ) : null
                  }
                  value={form.getField("email")}
                  htmlFor={"email"}
                />
              </div>

              <div className="mt-4">
                <ButtonBase
                  variant="primary"
                  type="submit"
                  label="Reset password"
                  onClick={() => {
                    handleForgotPassword();
                  }}
                  buttonBaseClasses={{
                    font: "text-xs md:text-sm font-medium",
                    backgroundColor: "bg-blue-600 hover:bg-blue-700",
                    textColor: "text-white",
                    border: "any",
                    width: "w-full",
                    padding: "px-4 py-3",
                  }}
                />
              </div>
            </>
          ) : (
            <>
              <h2 className="mt-6 text-3xl font-semibold text-gray-900 tracking-tight">
                Check your email
              </h2>
              <p className="mt-3 text-base text-gray-600">
                We sent a password reset link to
              </p>
              <p className="text-base font-medium text-gray-600">
                {guestUser?.email ? guestUser.email : ""}
              </p>

              <div className="py-5 text-sm text-gray-600">
                Didn’t receive the email?{" "}
                <ResendCode resendCallback={handleForgotPassword} />
              </div>
            </>
          )}
          <div className="py-5 bg-blue-gray-50">
            <Link href={"/login"}>
              <a className="text-sm font-medium text-gray-500 hover:text-blue-700 flex gap-x-2">
                <span aria-hidden="true">
                  <ChevronLeftSvg />
                </span>
                Back to log in
              </a>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
